export default "__VITE_ASSET__Cftj_6x5__"